import axiosInstance from "../../../utils/axios";
import { clearErrors, getErrors } from "./errors";

import { LOGIN_SUCCESS, LOGOUT_SUCCESS } from "./types";

export const login =
  ({ identifier, password }) =>
  (dispatch) => {
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };

    const body = JSON.stringify({ identifier, password });

    axiosInstance
      .post("auth/local", body, config)
      .then((res) => {
        dispatch({
          type: LOGIN_SUCCESS,
          payload: res.data,
        });
        dispatch(clearErrors());
      })
      .catch((err) => {
        // dispatch({
        //   type: LOGIN_FAIL,
        // });
        console.log("--------------------------");
        console.log(err.response.data.error.message);
        console.log("--------------------------");
        dispatch(
          getErrors({
            msg: err.response.data.error.message,
            status: err.response.data.error.status,
          })
        );
      });
  };

export const logout = () => (dispatch) => {
  dispatch({
    type: LOGOUT_SUCCESS,
  });
};

export const tokenConfig = (getState) => {
  const token = getState().auth.token;

  const config = {
    headers: {
      "Content-type": "application/json",
    },
  };

  if (token) {
    config.headers["Authorization"] = `Bearer ${token}`;
  }

  return config;
};
